import { api_react_v1_titv_past_events_path } from '@routes';

import request from './request';

export const TITV_PAST_EVENTS_KEY = 'titv_past_events';

export interface TITVEvent {
  id: number;
  coverUrl: string;
  date: string;
  datetime: string;
  description: string;
  duration: string;
  guid: string;
  title: string;
  videoId: string;
}

export interface LiveStream {
  videoId: string;
}

export interface TITVPastEventsResponse {
  currentPage: number;
  events: TITVEvent[];
  totalPages: number;
}

interface TITVEventsRequest {
  page: number;
  page_size: number;
}

export async function fetchTITVPastEvents(
  params: TITVEventsRequest
): Promise<TITVPastEventsResponse> {
  const response = await request('get', api_react_v1_titv_past_events_path(params));
  return response;
}
